import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import {
  NewVisitas,
  VisitaCuestionarioRequest,
  VisitaDetalle,
  VisitasRequest,
} from '../models/visitas.model';
import {
  CreateEvidenciaArchivoBody,
  EvidenciaArchivoFileResponse,
  EvidenciaArchivoParams,
  EvidenciaArchivoResponse,
} from '../models/evidencias.model';
import { GeneralService } from '../../shared/services/general.service';

@Injectable()
export class VisitasService {
  public URL_API = environment.apiURLNew;

  constructor(
    private http: HttpClient,
    private generalService: GeneralService,
  ) {}

  public newVisitas(body: NewVisitas, tenant?: string): Observable<VisitasRequest | null> {
    const params = tenant ? this.generalService.buildParams({ 'X-Tenant': tenant }) : undefined;
    return this.http.post<VisitasRequest>(this.URL_API + '/api/visitas', body, { params }).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  public saveCuestionario(publicId: string, body: VisitaCuestionarioRequest): Observable<boolean> {
    return this.http.put(`${this.URL_API}/api/visitas/${publicId}/cuestionario`, body).pipe(
      take(1),
      map(() => true),
      catchError(() => {
        return of(false);
      }),
    );
  }

  public getVisita(publicId: string): Observable<VisitaDetalle | null> {
    return this.http.get<VisitaDetalle>(`${this.URL_API}/api/visitas/${publicId}`).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  public uploadArchivo(
    params: EvidenciaArchivoParams,
    body: CreateEvidenciaArchivoBody,
  ): Observable<EvidenciaArchivoResponse | null> {
    const formData = new FormData();
    const evidenceType = body.tipo ?? params.tipo;
    const fileName = body.fileName ?? evidenceType ?? 'evidencia';

    formData.append('Tipo', evidenceType);
    formData.append('Archivo', body.archivo, fileName);

    if (body.fechaCaptura) {
      formData.append('FechaCaptura', body.fechaCaptura);
    }

    if (body.latitud !== undefined) {
      formData.append('Latitud', `${body.latitud}`);
    }

    if (body.longitud !== undefined) {
      formData.append('Longitud', `${body.longitud}`);
    }

    if (body.direccionCaptura !== undefined) {
      formData.append('DireccionCaptura', body.direccionCaptura);
    }

    return this.http
      .post<EvidenciaArchivoResponse>(
        `${this.URL_API}/api/visitas/${params.publicId}/evidencias`,
        formData,
      )
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public getArchivo(
    params: EvidenciaArchivoParams,
  ): Observable<EvidenciaArchivoFileResponse | null> {
    return this.http
      .get(`${this.URL_API}/api/visitas/${params.publicId}/evidencias/${params.tipo}/archivo`, {
        responseType: 'text',
      })
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }
}
